export default "__VITE_ASSET__8df5b35e__"